module.exports = __webpack_public_path__ + "img/media-10.aa3ee3bb.png";